export default {
  APP_EDIT_SUCCESS: "Aplicativo editado com sucesso",
};
